import { render, staticRenderFns } from "./Tabbar2.vue?vue&type=template&id=bd9ae49c&scoped=true"
import script from "./Tabbar2.vue?vue&type=script&lang=js"
export * from "./Tabbar2.vue?vue&type=script&lang=js"
import style0 from "./Tabbar2.vue?vue&type=style&index=0&id=bd9ae49c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9ae49c",
  null
  
)

export default component.exports